import React from "react";
import { Formik } from "formik";
import { TextField, withStyles, Button, Typography, FormControl, Fab } from "@material-ui/core";
import * as Yup from "yup";
import { Clear, Add } from '@material-ui/icons'
import { snackActions } from '../../sc-utilities/SnackBar';

import moment from 'moment'
const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    helperText: {
        marginTop: '4px'
    },
    cancel: {
        margin: theme.spacing(2),
        width: "40%"
    },
    formControl: {
        display: 'inline-block',
        width: "100%"
    },
    typography: {
        marginTop: '5px'
    },
    icon: {
        margin: theme.spacing(2)
    }
});

const DeviceDependentSettingsForm = props => {
    const { classes, formSettings, setSettingNumber, edit, initialValues, loading, handleSubmit, translations, settingNumber } = props;

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;

                    const handleClear = event => {
                        let number = event.currentTarget.getAttribute('value');
                        let array = [...settingNumber.settingNumber];
                        delete values[`Value_${number}`];
                        delete values[`Key_${number}`];
                        const index = array.indexOf(Number(number));
                        if (index > -1 && array.length > 1) {
                            array.splice(index, 1);
                        }
                        setSettingNumber({ ...settingNumber, settingNumber: array })
                    };

                    const handleAdd = event => {
                        let number = event.currentTarget.getAttribute('value')
                        let array = [...settingNumber.settingNumber]
                        if (values[`Key_${number}`] === '') {
                            return snackActions.snackBar({
                                message: 'Key cannot be empty!',
                                options: {
                                    variant: 'warning'
                                }
                            });
                        }
                        array.push(Number(number) + 1)
                        values[`Key_${Number(number) + 1}`] = ''
                        values[`Value_${Number(number) + 1}`] = ''
                        setSettingNumber({ ...settingNumber, settingNumber: array })
                    };

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="DependentType"
                                value={values.DependentType}
                                onChange={handleChange}
                                key={`dependentType`}
                                disabled={edit}
                                onBlur={handleBlur}
                                error={!!(errors.DependentType && touched.DependentType && errors.DependentType)}
                                placeholder={translations['name'] || 'Name'}
                                label={translations['name'] || 'Name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <Typography className={classes.typography} variant={"h6"}>{translations['settings'] || 'Settings'}</Typography>
                            {
                                settingNumber.settingNumber.map((number, index) =>
                                    <FormControl key={`${number} `} className={classes.formControl} margin={'dense'}>
                                        <TextField
                                            name={`Key_${number}`}
                                            id={`key_${number}`}
                                            value={values[`Key_${number}`] || ''}
                                            key={`Key_${number}`}
                                            onChange={handleChange}
                                            className={classes.cancel}
                                            onBlur={handleBlur}
                                            error={!!(errors[`Key_${number}`] && touched[`Key_${number}`] && errors[`Key_${number}`])}
                                            placeholder={translations['key'] || 'Key'}
                                            label={translations['key'] || 'Key'}
                                            margin={"dense"}
                                        />
                                        <TextField
                                            name={`Value_${number}`}
                                            id={`value_${number}`}
                                            value={values[`Value_${number}`] || ''}
                                            key={`Value_${number}`}
                                            onChange={handleChange}
                                            className={classes.cancel}
                                            onBlur={handleBlur}
                                            error={!!(errors[`Value_${number}`] && touched[`Value_${number}`] && errors[`Value_${number}`])}
                                            placeholder={translations['value'] || 'Value'}
                                            label={translations['value'] || 'Value'}
                                            margin={"dense"}
                                        />
                                        <Fab
                                            size={'small'}
                                            className={classes.icon}
                                            disabled={settingNumber.settingNumber.length === 1}
                                            key={`clear_${number}_${moment().indexOf}`}
                                            style={{ borderRadius: '1px' }}
                                            value={number}
                                            onClick={handleClear}
                                        >
                                            <Clear key={`clear_${number}_${moment().indexOf}`} />
                                        </Fab>
                                        {
                                            settingNumber.settingNumber.length === (index + 1) ?
                                                <Fab
                                                    size={'small'}
                                                    className={classes.icon}
                                                    style={{ borderRadius: '1px' }}
                                                    disabled={values[`Key_${number}`] === '' || values[`Key_${number}`] === undefined}
                                                    onClick={handleAdd}
                                                    value={number}
                                                    color={'primary'}
                                                >
                                                    <Add />
                                                </Fab> : null
                                        }
                                    </FormControl>
                                )
                            }
                            <div >
                                {
                                    formSettings.ButtonSubmit ? (
                                        <Button
                                            className={classes.submit}
                                            variant="contained"
                                            color={formSettings.ButtonSubmit.Color}
                                            type="submit"
                                            style={{ color: isSubmitting || loading || !(isValid && dirty) ? null : 'white' }}
                                            disabled={isSubmitting || loading || !(isValid && dirty)}
                                        >
                                            {formSettings.ButtonSubmit.Title}
                                        </Button>
                                    ) : null
                                }
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(DeviceDependentSettingsForm);
